import moment from "jalali-moment";
import SimpleTable from "../CustomTable/SimpleTable";
const ModuleTable = ({ data }) => {
  let headers = [];
  const tableData = [];
  const navigationLinke = `/admin`;
  switch (data[0].water_meter_type_info.water_meter_type_name) {
    case "سطح سنج":
      headers = [
        { title: "نام", key: "name" },
        { title: "شماره سریال", key: "serial" },
        { title: "زمان آخرین فعالیت", key: "lastTime" },
        { title: "آخرین داده", key: "lastData" },
        { title: "سویچ بالا", key: "topSwitch" },
        { title: "سویچ پایین", key: "bottomSwitch" },
        { title: "جزئیات", key: "details" },
      ];
      data.forEach((item) => {
        tableData.push({
          name: item.water_meter_name,
          serial: item.water_meter_serial,
          lastTime: moment(item.water_meter_status.last_consumption_time)
            .locale("fa")
            .format("YYYY/MM/DD"),
          lastData: "__",
          topSwitch: "__",
          bottomSwitch: "__",
          details: `live-devices/${item.water_meter_serial}`,
        });
      });
      break;

    default:
      headers = [];
      tableData = [];
      break;
  }
  return (
    <div style={{ padding: "0 10px" }}>
      <SimpleTable
        hasIndex={true}
        hasLink={true}
        darkHeader={true}
        navigation={navigationLinke}
        data={tableData}
        header={headers}
      />
    </div>
  );
};
export default ModuleTable;
